var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16.4 16.3",
    enableBackground: "new 0 0 16.4 16.3",
    xmlSpace: "preserve"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 2,
    strokeMiterlimit: 10,
    cx: 6.9,
    cy: 6.7,
    r: 5.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M10.7,10.4l4.3,4.2"
  })));
};
export default SvgSearch;